var _effectorFileName = "/src/shared/components/theme-toggle.tsx";
import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { IconType } from 'react-icons/lib';
import { RiComputerLine, RiMoonLine, RiSunLine } from 'react-icons/ri';
import { Label } from './ui/label';
import { Switch } from './ui/switch';
interface ThemeToggleProps {
  withText?: boolean;
}
const themeIcons: Record<string, IconType> = {
  light: RiSunLine,
  dark: RiMoonLine,
  system: RiComputerLine
} as const;
export const ThemeToggle = (props: ThemeToggleProps) => {
  const {
    withText = true
  } = props;
  const {
    theme = 'light',
    setTheme
  } = useTheme();
  const ThemeIcon = themeIcons[theme];
  const [isChecked, setChecked] = useState(false);
  useEffect(() => {
    if (theme === 'dark' || theme === 'system') {
      setChecked(true);
      return;
    }
    setChecked(false);
  }, [setChecked, theme]);
  const onCheckedChange = () => {
    if (theme === 'dark' || theme === 'system') {
      setTheme('light');
      return;
    }
    setTheme('dark');
  };
  return <div className="flex items-center space-x-4">
      <Switch id="airplane-mode" checked={isChecked} onCheckedChange={() => onCheckedChange()} />

      {withText && <Label htmlFor="airplane-mode">{isChecked ? 'Светлая тема' : 'Темная тема'}</Label>}

      {!withText && <Label htmlFor="airplane-mode">
          <ThemeIcon size="18px" />
        </Label>}
    </div>;
};